import React from "react";
import { useTranslation } from "react-i18next";

export default function EraseOne(props) {
  // console.log('props.activeButton -----HAND', props.activeButton)
  const { t } = useTranslation();
  return (
    <li onClick={!props.hideButton ? props.onClick : undefined}>
      <span
        className={`button normal-btn erase ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        } ${props.activeButton === "eraseselected" ? "active" : ""}`}
        title={t("Erase") + " (Del/Backspace)"}
        // onClick={props.onClickEraser}
        data-tip={t("Erase")}
      >
        <img
          src={require("../../assets/img/svg/tools-eraser.svg")}
          alt={t("Erase") + " (Del/Backspace)"}
        />
        {props.shouldShowButtonLabels && (
          <span className="show-label-text">{t("Eraser")}</span>
        )}
      </span>
    </li>
  );
}
